/*
 * assets/js/src/paticka.js — odkazové sloupce patičky jako akordeon.
 *
 * ---------------------------------------------------------------------
 * CO TENHLE MODUL DĚLÁ A CO NE
 * ---------------------------------------------------------------------
 * Rozbalování NEOBSLUHUJE. Sloupce jsou `<details>` a to umí prohlížeč sám
 * — klepnutí na `summary` je záležitost nativního chování, ne skriptu.
 *
 * Modul řeší JEDINOU věc: výchozí stav podle šířky okna. Markup je od
 * 19. 9. 2026 bez atributu `open` (rozhodnutí majitele: „patička na
 * mobilu má být defaultně zabalená"), takže sbaleno je výchozí stav
 * všude. Nad 768 px se `open` doplní, pod 768 px se zase odebere.
 *
 * ---------------------------------------------------------------------
 * PROČ TO NENÍ JEN CSS
 * ---------------------------------------------------------------------
 * `chrome.css` na desktopu otevírá i zavřený `<details>` dvojicí
 * `display: block` + `::details-content { content-visibility: visible }`.
 * To funguje BEZ JS, ale `::details-content` je Chrome 131+ / Safari 18.4+,
 * kdežto `.browserslistrc` deklaruje Safari 14.1. Tenhle modul je ta
 * druhá, konzervativní cesta pro starší prohlížeče — a zároveň jediná,
 * která zabere při změně velikosti okna.
 *
 * ---------------------------------------------------------------------
 * PROČ SE PŘI ZMENŠENÍ OKNA ZAVÍRÁ
 * ---------------------------------------------------------------------
 * Bez toho by desktopový návštěvník, který si okno zúží (nebo otočí
 * tablet), zdědil na mobilní šířce rozbalenou patičku — přesně stav,
 * který majitel reklamoval. Stav se proto přepočítá při každé změně
 * dotazu, ne jen při načtení.
 *
 * Co se NEPŘENÁŠÍ: ruční volba. Když si někdo na mobilu sloupec otevře
 * a nechá šířku být, modul do toho nesahá — píše jen při PŘEKLOPENÍ
 * dotazu. Každý sloupec je vlastní `<details>`, takže se stav nepřenáší
 * ani mezi sloupci.
 */

const DOTAZ = '(min-width: 768px)';

export function init() {
	const sloupce = document.querySelectorAll('footer .facc');
	if (!sloupce.length) return 0;

	/*
	 * `matchMedia` chybí jen v prohlížečích hluboko pod naší podlahou.
	 * Kdyby přesto chyběl, nechá se markup být: sbalený stav je ten
	 * bezpečný, patička je i tak plně ovladatelná klepnutím.
	 */
	if (!window.matchMedia) return 0;

	const mq = window.matchMedia(DOTAZ);

	const sesad = (desktop) => {
		for (const s of sloupce) {
			if (desktop) s.setAttribute('open', '');
			else s.removeAttribute('open');
		}
	};

	sesad(mq.matches);

	/*
	 * `addEventListener` na `MediaQueryList` je Safari 14+; starší
	 * `addListener` je odložený zbytek, který u nás žádné zařízení
	 * nepotřebuje — podlaha je Safari 14.1.
	 */
	mq.addEventListener('change', (e) => sesad(e.matches));

	return sloupce.length;
}
